export const BLEND_AND_EXTEND_DISCOUNT_TYPES = [
  'extendRenewalBenefit1Year',
  'extendRenewalBenefit3Year',
  'extendStayersAdvantage1Year',
  'extendStayersAdvantage3Year',
];
